import { render, staticRenderFns } from "./OptionHandlerMatchMaking.vue?vue&type=template&id=b29a0abc"
import script from "./OptionHandlerMatchMaking.vue?vue&type=script&lang=js"
export * from "./OptionHandlerMatchMaking.vue?vue&type=script&lang=js"
import style0 from "./OptionHandlerMatchMaking.vue?vue&type=style&index=0&id=b29a0abc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports